export const COUPON_RESOURCE_PATH = '/v1/coupon-card/coupon-card/{{type}}/{{code}}';
export const COUPON_TRANSACTION_RESOURCE_PATH = '/v1/coupon-card/coupon-card';
export const DAILY_BALANCE_RESOURCE_PATH = '/v1/coupon-card/daily-balance';
